import { useSelector } from "react-redux";

const NetworkBanner = () => {
  const { isOffline, isServerDown } = useSelector((state) => state.auth);

  if (!isOffline && !isServerDown) return null;

  let message = "";

  if (isOffline) {
    message = "⚠️ No Internet Connection. Please check your network.";
  } else if (isServerDown) {
    message = "Server is unreachable. Please try again later.";
  }

  return (
    <div style={{
      position: "fixed",
      top: 0,
      width: "100%",
      background: "#ff4d4f",
      color: "#fff",
      textAlign: "center",
      padding: "10px",
      zIndex: 9999,
      fontWeight: "bold"
    }}>
      {message}
    </div>
  );
};

export default NetworkBanner;